module.exports = __webpack_public_path__ + "static/img/scene_photo_marine.c22e06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_photo_marine.jpg
// module id = cUoM
// module chunks = 1